import { useState, useRef, useCallback } from 'react';
import { useRequestData } from 'wsm-common-data';
import { galleryTrackingEvents } from '../utilities/tracking';
import { GALLERY_TABS } from '../constants/galleryTabs';

const useGalleryModal = () => {
	const primarySliderRef = useRef(null);
	const { widgetName, windowId } = useRequestData();

	const [openModal, setOpenModal] = useState(false);
	const [carouselIndex, setCarouselIndex] = useState(0);
	const [activeTab, setActiveTab] = useState(GALLERY_TABS.PHOTOS);

	const onOpenModal = useCallback(() => {
		const bodyContainer = document.body;
		bodyContainer.classList.add('overflow-hidden');
		setOpenModal(true);
	}, []);

	const onClose = useCallback(() => {
		galleryTrackingEvents.closeModal(widgetName, windowId);

		const bodyContainer = document.body;
		bodyContainer.classList.remove('overflow-hidden');
		// Sync primary slider to current carousel position after modal closes
		setTimeout(() => {
			if (
				primarySliderRef.current &&
				primarySliderRef.current?.slickGoTo
			) {
				primarySliderRef.current.slickGoTo(carouselIndex, true);
			}
		}, 400);
		setOpenModal(false);
		setActiveTab(GALLERY_TABS.PHOTOS);
	}, [widgetName, windowId, carouselIndex]);

	return {
		openModal,
		setOpenModal,
		carouselIndex,
		setCarouselIndex,
		activeTab,
		setActiveTab,
		primarySliderRef,
		onOpenModal,
		onClose
	};
};

export default useGalleryModal;
